import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { usePages, buildPageUrl, useUser, useAnalytics, useNeuroState } from '@ignitesales/neuro-application/src/neuro-guide';
import ShareViaSmsModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaSmsModal';
import ShareViaEmailModal from './modals/ShareViaEmailModal';
import ShareViaEmailComplete from './modals/ShareViaEmailComplete';
import useSubmittedProducts from '../hooks/useSubmittedProducts';

import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import HeaderMenu from './modals/HeaderMenu';
import ShoppingCartModal from './modals/ShoppingCartModal';

const Header = ({ className, productsInCart }) => {

  const [ showMenu, setShowMenu ] = useState(false);
  const [showShareViaSmsModal, setShowShareViaSmsModal] = useState(false);
  const [showShareViaEmailModal, setShowShareViaEmailModal] = useState(false);
  const [showShareViaEmailComplete, setShowShareViaEmailComplete] = useState(false);
  const [onEmailSubmission, setOnEmailSubmission] = useState(false);
  const [showShoppingCartModal, setShowShoppingCartModal] = useState(false);
  
  const [filteredProductsInCart, setFilteredProductsInCart] = useState([]); // State to store only productsInCart that haven't been submitted
  const { submittedProductsState = {} } = useNeuroState();
  const submittedIds = submittedProductsState?.submittedIds || [];
  const { getNotSubmittedProducts } = useSubmittedProducts();

  const { currentPageUrl } = usePages();
  const { uuid } = useUser();
  const { actionCompleted, actionStarted } = useAnalytics();

  const componentClass = 'header-summary';

  const classes = classnames(
    componentClass,
    className
  );

  useEffect(() => {  
    if(submittedIds) {
      const filteredProductList = getNotSubmittedProducts(productsInCart, submittedIds);
      setFilteredProductsInCart(filteredProductList);
    } else {
      setFilteredProductsInCart(productsInCart);
    }

  }, [submittedIds, productsInCart]);


  const onEmailComplete = () => {
    setOnEmailSubmission(true);
    actionCompleted({ actionName: 'shareViaEmailCompleted' });
  };

  const onShareViaSmsClicked = () => {
    setShowShareViaSmsModal(true);
    actionStarted({ actionName: 'shareViaSmsClicked' });
  };

  const onShareViaEmailClicked = () => {
    setShowShareViaEmailModal(true);
    actionStarted({ actionName: 'shareViaEmailClicked' });
  };


  const shareViaSmsModal = (
  
    <ShareViaSmsModal
      className={`${componentClass}__smsModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaSmsModal}
      onClose={() => setShowShareViaSmsModal()}
    />
  );

  const shareViaEmailModal = (
    <ShareViaEmailModal
      className={`${componentClass}__emailModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailModal}
      onClose={() => setShowShareViaEmailModal(false)}
      onEmailComplete={onEmailComplete}
    />
  );


  const headerMenuModal = (
    <HeaderMenu 
      showMenu={showMenu} 
      setShowMenu={setShowMenu} 
      currentPage={currentPageUrl}
      onClose={() => setShowMenu(false)}
    />
  );

  const shoppingCartModal = (
    <ShoppingCartModal
      className={`${componentClass}__shoppingCartModal`}
      showMenu={showShoppingCartModal}
      setShowMenu={setShowShoppingCartModal}
      currentPage={currentPageUrl}
      onClose={() => setShowShoppingCartModal(false)}
      productsInCart={filteredProductsInCart}
    />
  );

  const detailsUrl = buildPageUrl({
    type: 'details',
    uuid
  });

  const onPrintClick = () => {
    if (detailsUrl) {
      window.open(detailsUrl);
    }
  };

  const cartItemsCount = filteredProductsInCart?.length || 0;

  return <>
    <header className={classes}>
      <div className="logo">
        <ReactSVG src="/classpath/assets/images/commerce_logo_full.svg" />
      </div>

      <div className="actions">
      <button className="header-summary-menu-btn" onClick={onPrintClick}>
        <ReactSVG src="/classpath/assets/images/icons/print-green.svg" />
      </button>
      <button className="header-summary-menu-btn" onClick={onShareViaSmsClicked} >
        <ReactSVG src="/classpath/assets/images/icons/phone-green.svg" />
      </button>
      <button className="header-summary-menu-btn" onClick={onEmailSubmission ? () => { setShowShareViaEmailComplete(true); } : onShareViaEmailClicked}>
        <ReactSVG src="/classpath/assets/images/icons/mail-green.svg" />
      </button>
      { (currentPageUrl && currentPageUrl !== "/guide" && !currentPageUrl.includes("details")) && <button className="header-summary-menu-btn" onClick={() => setShowMenu(true)} >
        <ReactSVG src="/classpath/assets/images/icons/icon-hamburger.svg" />
      </button>}
      <button className="header-summary-menu-btn solid" onClick={() => setShowShoppingCartModal(true)} >
        <ReactSVG src="/classpath/assets/images/icons/shopping_cart.svg" />
        <span className="header-summary-menu-btn__count" >{cartItemsCount}</span>
      </button>
      </div>




    </header>
    {shoppingCartModal}
    {headerMenuModal}
    {shareViaSmsModal}
    {shareViaEmailModal}
  </>;
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
